import { render, staticRenderFns } from "./TruncateTooltip.vue?vue&type=template&id=57897234&scoped=true&"
import script from "./TruncateTooltip.vue?vue&type=script&lang=ts&"
export * from "./TruncateTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./TruncateTooltip.vue?vue&type=style&index=0&id=57897234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57897234",
  null
  
)

export default component.exports